import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";

const WinterStorage = () => {
    return (
    <div className="about-page">
      <>
          <Helmet>
              <title>Pro Moto - zimowanie, przechowanie motocykli</title>
              <meta
              name="description"
              content="PRO MOTO Zimowanie, przechowanie motocykli"
              />
              <link rel="canonical" href="https://promotoserwis.pl/zimowanie" />
          </Helmet>
      </>
      <section className="about-hero">
        <div className="about-hero__content">
         <motion.h1
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            >Zimowanie, przechowanie motocykli</motion.h1>
         <motion.p
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
              <strong>Ogrzewana i monitorowana przechowalnia</strong></motion.p>
          <motion.p
            initial={{ opacity: 0, y: 90 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
           Mróz, wilgoć i sól drogowa nie mają litości dla metalu, 
           uszczelek i lakieru. Jeśli chcesz, by wiosną motocykl odpalił „na dotyk” 
           i od razu był gotów do sezonu, zaufaj profesjonalnej przechowalni. 
           Oferujemy ogrzewane, strzeżone miejsce postojowe, konserwację, regularne doładowywanie 
           akumulatora oraz pełne ubezpieczenie – a wszystko to kilka minut od centrum Poznania.
          </motion.p>


          <button
            className="about-scroll-btn"
            onClick={() =>
              document.querySelector(".about-extra").scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="arrow"></span>
          </button>
        </div>
      </section>


      <section className="about-extra">
        <div className="about-extra__container">

          <div className="about-block">
            <h2>Dlaczego zimowanie w profesjonalnej przechowalni to konieczność?</h2>
            <p>Wielu motocyklistów decyduje się zostawić sprzęt w przydomowym garażu lub pod plandeką. 
              Z zewnątrz wydaje się to wygodne, ale w praktyce niesie ze sobą szereg zagrożeń:</p>
            <ul>
                <li>
                  <strong>Wilgoć i kondensacja:</strong>w nieogrzewanych pomieszczeniach temperatura spada nocą poniżej punktu rosy, a nagrzewa się w dzień. 
                  Para wodna osadza się na metalach, wywołując mikrokorozję i niszcząc instalację paliwową..
                  </li>
                <li>
                  <strong>Zasiarczony akumulator:</strong> całkowite rozładowanie przez kilka miesięcy potrafi zabić nawet nową baterię.
                  </li>
                <li>
                  <strong>Utlenione paliwo i gumiejące uszczelki:</strong> benzyna traci właściwości po kilku tygodniach, a etanol chłonie wodę – efektem jest 
                zapchany układ wtryskowy lub gaźnik.
                </li>
                <li>
                  <strong>Gryzonie</strong> myszy i kuny uwielbiają gniazdować w motocyklowych owiewkach i gryźć przewody
                  zapchany układ wtryskowy lub gaźnik.
                </li>
                <li>
                  <strong>Bezpieczeństwo</strong> włam w garażu osiedlowym czy piwnicy bywa kwestią kilku minut, a 
                  towarzystwa ubezpieczeniowe brutalnie tną wypłaty, jeśli maszyna nie była należycie zabezpieczona.
                  </li>
            </ul>
            <p>Profesjonalna przechowalnia eliminuje każdy z tych problemów.</p>
          </div>
          <div className="about-block">
            <h2>Co dokładnie obejmuje usługa zimowania/przechowania w PRO MOTO?</h2>
          </div>
          <div className="about-block">
            <h2>Suche pomieszczenie</h2>
            <p>Pomieszczenie utrzymywana jest w stałej temperaturze, co zapobiega kondensacji wilgoci.</p>
          </div>
          <div className="about-block">
            <h2>Monitoring i ochrona</h2>
            <p>Cały obiekt objęty jest CCTV i systemem alarmowym.. 
              Twoja maszyna spędza zimę pod równie czujnym okiem kamer, co motory w salonie dealerskim.</p>
          </div>
          <div className="about-block">
            <h2>Trickle-charge akumulatora</h2>
            <p>
                Raz na dwa tygodnie podłączamy prostownik z funkcją ładowania podtrzymującego. 
                Wiosną akumulator jest w pełni gotowy, więc unikasz kosztownej wymiany.
            </p>
          </div>

          <div className="about-block">
            <h2>Osłona antykurzowa</h2>
            <p>Prosimy o dostarczenie własnego pokrowca.</p>
          </div>
          
          <div className="about-block">
            <h2>Ubezpieczenie OC/AC w przechowalni</h2>
            <p>W cenie zimowania zawarte jest dodatkowe ubezpieczenie magazynowe, 
              które chroni pojazd nawet w skrajnych sytuacjach losowych.</p>
          </div>
          <div className="about-block">
            <h2>Jak to wygląda krok po kroku?</h2>
            <ol>
                <li><strong>Rezerwacja terminu</strong> – zadzwonisz lub wyślesz formularz; wybierasz opcję przyjazdu własnego albo transportu door-to-door.</li>
                <li><strong>Przygotowanie motocykla</strong> – przed wstawieniem motocykla umyj go zdejmij kufry, sakwy, zabierz ze sobą pokrowiec i zatankuj zbiornik paliwem min 3/4.</li>
                <li><strong>Protokół zdawczo-odbiorczy</strong> – w Twojej obecności sporządzamy dokument ze zdjęciami stanu motocykla; to gwarancja braku sporów przy odbiorze.</li>
                <li><strong>Wybudzenie</strong> – dwa dni przed odbiorem sprawdzamy ciśnienie opon, poziom oleju i napięcie akumulatora. Na życzenie za niewielką dopłatą wykonujemy 
                szybki przegląd kontrolny (płyn hamulcowy, światła, klocki).</li>
            </ol>
          </div>
          <div className="about-block ">
            <h2>Dodatkowe usługi, które możesz zamówić przy zimowaniu</h2>
            <ul>
                <li><strong>Serwis „start-sezon</strong> – wymiana oleju, filtrów, świec i regulacja łańcucha dokładnie w momencie wybudzenia.</li>
                <li><strong>Zmiana opon</strong> – wymień zużyty komplet, zanim pojawią się kolejki w warsztatach w marcu.</li>
                <li><strong>Transport z i do przechowalni</strong> – odbierzemy Twoją maszynę jesienią i odwieziemy wiosną pod dom lub pod pracę</li>
            </ul>
          </div>
          <div className="about-block">
            <h2>Odpowiedzi na najczęstsze pytania</h2>
            <ul>
                <p>
                    <strong>Ile wcześniej muszę rezerwować miejsce?</strong> <br/>
                    W szczycie sezonu (październik) miejscówki schodzą szybko; najlepiej zarezerwować dwa-trzy tygodnie przed planowanym przyjazdem.
                </p>
                <p>
                    <strong>Czy mogę przyjść obejrzeć motocykl w trakcie zimy?</strong> <br/>
                    Oczywiście. Wystarczy jeden dzień wcześniejszej zapowiedzi – przygotujemy maszynę, abyś mógł w spokoju sprawdzić, czy wszystko jest w porządku
                </p>
                <p>
                    <strong>Jak długi jest okres zimowania?</strong> <br/>
                    Standard to 1 października – 31 marca, ale możemy wydłużyć lub skrócić pobyt według potrzeb, rozliczając dni proporcjonalnie. 
                    Podczas sezonu motocyklowego tez możemy przechować twój pojazd.
                </p>
                <p>
                    <strong>Czy muszę wyciągać akumulator?</strong> <br/>
                    Nie, robimy to za Ciebie. Akumulator ląduje na półce serwisowej, gdzie podłączamy prostownik.
                </p>
            </ul>
          </div>
          <div className="about-block ">
            <h2>Dlaczego PRO MOTO, a nie zwykły garaż?</h2>
            <ul>
                <li><strong>Doświadczenie:</strong> od dekady zimujemy kilkadziesiąt motocykli rocznie; żaden nie wrócił z rdzą czy padniętym aku.</li>
                <li><strong>Transparentność:</strong> pełny cennik na stronie, żadnych „ukrytych opłat”.</li>
                <li><strong>Lokalizacja:</strong> Roztworowo – szybki dojazd, blisko S11.</li>
                <li><strong>Kompleksowość:</strong> serwis, opony, transport – wszystko w jednym miejscu, bez wożenia motocykla od specjalisty do specjalisty.</li>
            </ul>
          </div>
          <div className="about-block ">
            <h2>Jak zarezerwować miejsce?</h2>
            <ol>
                <li>Zadzwoń pod<strong>+48 535744816</strong> lub wypełnij napisz mail.</li>
                <li>Podaj markę, model i preferowaną datę przyjazdu.</li>
                <li>Otrzymasz mail z potwierdzeniem rezerwacji oraz instrukcją, jak przygotować motocykl.</li>
                <li>Liczba miejsc jest ograniczona, bo nie upychamy motocykli „na styk”. Każda sztuka ma własną, bezpieczną przestrzeń. Gdy hala się wypełni, zamykamy rejestrację aż do wiosny.</li>
            </ol>
          </div>
          <div className="about-block " >
            <h2>Podsumowanie</h2>
            <p style={{paddingBottom:"40px"}}>
              Zimowanie motocykla to nie luksus, lecz inwestycja w długowieczność Twojej maszyny i Twój spokój. 
              Ochrona 24/7, ładowanie akumulatora i konserwacja pozwalają zakończyć sezon bez stresu, 
              a rozpocząć nowy z pełnym uśmiechem. PRO MOTO gwarantuje, 
              że pierwsze wiosenne przekręcenie kluczyka kończy się pewnym uruchomieniem motocykla. <br/>
              Zabezpiecz swój motocykl już dziś – <strong>zadzwoń</strong>, zanim skończą się wolne miejsca. 
              Niech zima pracuje nad tym, żeby Twoja maszyna wiosną była jeszcze lepsza, a nie gorsza.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
};




export default WinterStorage;
